import { LINKS } from "@/lib/brand";
import { ArrowUpRight } from "lucide-react";

const tiles = [
  {
    key: "calendly",
    label: "Consult · 15 min",
    title: "Book a Call",
    desc: "Real estate strategy, brand collab, or UGC brief — book a free 15 min intro on Calendly.",
    href: LINKS.calendly,
    image: "/tiles/calendly.png",
  },
  {
    key: "ugc",
    label: "Backstage · UGC",
    title: "UGC Creator",
    desc: "Organic, on-camera content for lifestyle, beauty, real estate and hospitality brands.",
    href: LINKS.backstageUGC,
    image: "/tiles/ugc.png",
  },
  {
    key: "model",
    label: "Backstage · Talent",
    title: "Model & Acting",
    desc: "Represented on Backstage for modeling and on-camera talent bookings.",
    href: LINKS.backstageModel,
    image: "https://images.unsplash.com/photo-1542038784456-1ea8e935640e?auto=format&fit=crop&w=800&q=80",
  },
  {
    key: "amazon",
    label: "Storefront",
    title: "Amazon Shop",
    desc: "Curated lifestyle, wellness and home favourites — everything I actually use.",
    href: LINKS.amazon,
    image: "https://images.unsplash.com/photo-1481437156560-3205f6a55735?auto=format&fit=crop&w=800&q=80",
  },
  {
    key: "instagram",
    label: "@stefwinstan",
    title: "Instagram",
    desc: "Daily content on real estate, lifestyle, behind-the-scenes.",
    href: LINKS.instagram,
    image: "/tiles/instagram.png",
  },
  {
    key: "linkedin",
    label: "Professional",
    title: "LinkedIn",
    desc: "Connect with me on LinkedIn for business, referrals and partnerships.",
    href: LINKS.linkedin,
    image: "/tiles/linkedin.png",
  },
];

export const Services = () => {
  return (
    <section id="create" data-testid="services-section" className="py-24 md:py-32 bg-ivory border-t border-charcoal/10">
      <div className="container-edit">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end mb-14">
          <div className="md:col-span-8">
            <div className="overline mb-5">— 04 / Everything Else I Do</div>
            <h2 className="font-serif-heading text-4xl md:text-6xl text-charcoal leading-[1]" data-testid="services-title">
              One link<br />
              <span className="italic text-bronze-deep">for everything.</span>
            </h2>
          </div>
          <p className="md:col-span-4 text-ink text-base leading-relaxed">
            Content creation, UGC, modeling, brand partnerships and my
            personal picks — all in one place.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="services-grid">
          {tiles.map((t) => (
            <a
              key={t.key}
              href={t.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`service-tile-${t.key}`}
              className={`group relative border border-charcoal/10 hover:border-bronze transition-colors duration-300 flex flex-col overflow-hidden ${t.emphasis ? "bg-charcoal text-ivory hover:border-charcoal" : "bg-ivory text-charcoal"}`}
            >
              {/* Photo header */}
              <div className="relative aspect-[16/9] overflow-hidden bg-charcoal/10">
                <img
                  src={t.image}
                  alt={t.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.06]"
                />
                <div className={`absolute inset-0 ${t.emphasis ? "bg-charcoal/30" : "bg-charcoal/10 group-hover:bg-charcoal/0"} transition-colors duration-500`} />
                <ArrowUpRight
                  size={18}
                  strokeWidth={1.4}
                  className={`absolute top-4 right-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1 ${t.emphasis ? "text-ivory" : "text-ivory drop-shadow"}`}
                />
              </div>
              {/* Body */}
              <div className="p-7 md:p-8 flex-1 flex flex-col">
                <div className={`overline ${t.emphasis ? "!text-bronze" : ""}`}>{t.label}</div>
                <h3 className={`font-serif-heading text-2xl md:text-3xl mt-2 leading-tight ${t.emphasis ? "text-ivory" : "text-charcoal"}`}>
                  {t.title}
                </h3>
                <p className={`mt-3 text-sm leading-relaxed ${t.emphasis ? "text-ivory/75" : "text-ink"}`}>
                  {t.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
